import {
  BadgeStatus,
  IntegrationSyncRun,
  IntegrationSyncStatus,
} from '@aslanpay/portal-common-lib';

export const SYNC_STATUS_DETAILS: Record<
  IntegrationSyncStatus,
  { label: string; badgeStatus: BadgeStatus }
> = {
  SUCCESS: { label: 'Success', badgeStatus: 'active' },
  PARTIAL_SUCCESS: { label: 'Partial success', badgeStatus: 'warning' },
  FAILED: { label: 'Failed', badgeStatus: 'left' },
};

/**
 * A sync run's outcome. Runs recorded before tpg set a status carry only the success flag, so the outcome is read
 * from that for them.
 */
export const getRunSyncStatus = (run: Pick<IntegrationSyncRun, 'success' | 'status'>) =>
  run.status ?? (run.success ? 'SUCCESS' : 'FAILED');
